import { map } from "lodash-es";

import { MDSIconKind } from "@/mds";
import type { AgentFilterSelectItem } from "@/pages/agent/components/agent-filter-select";
import { formatStatusLabel } from "@/pages/agent/utils/agent-status.utils";
import {
  ALL_PROJECT_STATUSES_FILTER,
  ProjectSortKey,
} from "@/pages/agent/projects/use-agent-projects-search-params";

export const buildProjectSortFilterItems = (): AgentFilterSelectItem[] => [
  {
    id: ProjectSortKey.RecentlyActive,
    label: "Recently active",
    iconKind: MDSIconKind.SortAlt,
  },
  {
    id: ProjectSortKey.Alphabetical,
    label: "Alphabetical",
    iconKind: MDSIconKind.SortAlt,
  },
];

export const buildProjectStatusFilterItems = ({
  statusFilter,
  statusFilterValues,
}: {
  statusFilter: string;
  statusFilterValues: string[];
}): AgentFilterSelectItem[] => {
  const statusFilterItems: AgentFilterSelectItem[] = [
    {
      id: ALL_PROJECT_STATUSES_FILTER,
      label: "All statuses",
      iconKind: MDSIconKind.Filter,
    },
  ];
  const hasSelectedStatus =
    statusFilter === ALL_PROJECT_STATUSES_FILTER || statusFilterValues.includes(statusFilter);

  if (!hasSelectedStatus) {
    statusFilterItems.push({
      id: statusFilter,
      label: formatStatusLabel({ status: statusFilter }),
      iconKind: MDSIconKind.Filter,
    });
  }

  statusFilterItems.push(
    ...map(statusFilterValues, status => ({
      id: status,
      label: formatStatusLabel({ status }),
      iconKind: MDSIconKind.Filter,
    }))
  );

  return statusFilterItems;
};
